import {useCallback, useEffect, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {Skeleton} from 'src/components/skeleton'
import {useAuth} from 'src/contexts/AuthContext'
import {useNavigationMenu} from 'src/layouts/main-layout/app-sidebar/navigation/hooks/use-navigation-menu.hook'
import {applyNavigationMenuVisibility} from 'src/layouts/main-layout/app-sidebar/navigation/utils/apply-navigation-menu-visibility'
import {navigationMenuVisibilityRules} from 'src/layouts/main-layout/app-sidebar/navigation/utils/navigation-menu-visibility-rules'
import {useAppSidebar} from './app-sidebar-context'
import {AppSidebarNavItem} from './app-sidebar-nav-item'

export function AppSidebarNav() {
  const {user, userIsB2c} = useAuth()
  const {data: menuFromApi, isLoading} = useNavigationMenu()
  const {collapsed, expandedItemId, setExpandedItemId} = useAppSidebar()
  const {pathname} = useLocation()
  const [hoverCardItemId, setHoverCardItemId] = useState<string | null>(null)

  const handleOpenChange = useCallback(
    (id: string, open: boolean) => {
      setExpandedItemId(open ? id : null)
    },
    [setExpandedItemId],
  )

  const handleHoverCardOpenChange = useCallback((id: string, open: boolean) => {
    setHoverCardItemId((prev) => (open ? id : prev === id ? null : prev))
  }, [])

  useEffect(() => {
    setHoverCardItemId(null)
  }, [collapsed, pathname])

  const menu = useMemo(
    () =>
      menuFromApi
        ? applyNavigationMenuVisibility(menuFromApi, user?.permissions ?? [], navigationMenuVisibilityRules, {
            userIsB2c,
          })
        : undefined,
    [menuFromApi, user?.permissions, userIsB2c],
  )

  if (isLoading) {
    return (
      <nav data-slot='sidebar-nav' className='flex flex-col gap-3'>
        {Array.from({length: 5}).map((_, i) => (
          <Skeleton key={i} className='h-10 w-full' />
        ))}
      </nav>
    )
  }

  return (
    <nav data-slot='sidebar-nav' className='flex flex-col'>
      {menu?.map((navigationMenu) => (
        <AppSidebarNavItem
          key={navigationMenu.id}
          navigationMenu={navigationMenu}
          isOpen={expandedItemId === navigationMenu.id}
          onOpenChange={handleOpenChange}
          isHoverCardOpen={hoverCardItemId === navigationMenu.id}
          onHoverCardOpenChange={(open: boolean) => handleHoverCardOpenChange(navigationMenu.id, open)}
        />
      ))}
    </nav>
  )
}
